import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';

export const IconMuiV3 = styled.div`
  font-family: 'Material Icons', sans-serif;
  font-weight: 400;
  font-size: 24px;
  color: ${COLORS.black};
  @media screen and (min-width: 992px) {
    color: ${COLORS.colorPrimary};
  }
`;
